import React from "react";
import { useDispatch, useSelector } from "react-redux";
import closeIcon from "../assets/images/close.svg";
import { setSearchString } from "../features/filter/filterSlice";

const ClearFilter = () => {
  const { searchString } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const handleClearSearch = () => {
    dispatch(setSearchString(""));
  };
  return searchString ? (
    <div className='clear-filter-section'>
      <div className='single-filter'>
        <p>{`Showing results for: ${searchString}`}</p>
        <img className='close-icon' src={closeIcon} alt='close' onClick={handleClearSearch} />
      </div>
    </div>
  ) : null;
};

export default ClearFilter;
